import React, { Component } from 'react';
import PropTypes from 'prop-types';
import b from 'b_';
import cn from 'classnames';
import './Pill.css';

export const PILL = {
    GRAY: 'gray',
    GREEN: 'green',
    RED: 'red'
};

const block = b.lock('Pill');

export default class Pill extends Component {
    static propTypes = {
        type: PropTypes.oneOf(Object.values(PILL)),
        iconLeft: PropTypes.node,
        className: PropTypes.string
    };

    render() {
        const { children, type, className } = this.props;

        return <div className={cn(block({ type }), className)}>
            {this.props.iconLeft} {children}
        </div>;
    }
}

export function GrayInlinePill({ children }) {
    return <Pill
        className={block('InlineBlock')}
        type={PILL.GRAY}
    >
        {children}
    </Pill>;
}
